// extracted by mini-css-extract-plugin
export default {"item":"TableProductItem_item__qKKpG","bodyColumn":"TableProductItem_bodyColumn__oxOZi","imageLimit":"TableProductItem_imageLimit__3L3WE","img":"TableProductItem_img__X7wo0"};